import type { ColumnDef, Row } from "@tanstack/react-table";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type ColumnDefinition<T> = ColumnDef<T>;
export type RowData<T> = Row<T>;
